/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { CopyToClipboard } from "react-copy-to-clipboard";
import { When } from "react-if";
import { Link, generatePath } from "react-router-dom";
import { FlexContainer, SVGIcon, theme } from "@nordcloud/gnui";
import { ExternalLinkWithIndicator } from "~/components";
import { SUCCESS_TEXT } from "~/constants";
import { getProviderTooltip } from "~/hooks/useConsoleUrl/utils";
import { ROUTES } from "~/routing/routes";
import { showSimpleInfo } from "~/services/toast";
import { isNotEmpty, trimTextBeginning } from "~/tools";
import { ResourceDetails } from "./components";

type Props = {
  id: string;
  type?: string;
  category?: string;
  nordcloudId: string;
  name: string;
  url?: string;
  provider: string;
  region?: string;
};

export function ResourceNameDetailsCell({
  id,
  type,
  category,
  name,
  nordcloudId,
  url,
  provider,
  region,
}: Props) {
  const resourceName = isNotEmpty(name) ? name : id;
  const caption = getProviderTooltip(provider);

  const externalUrl = url ?? "";

  return (
    <>
      <FlexContainer>
        <Link
          title={resourceName}
          to={generatePath(ROUTES.resource, {
            nordcloudId,
          })}
          css={{
            whiteSpace: "nowrap",
          }}
        >
          {trimTextBeginning(resourceName, 30)}
        </Link>
        <CopyToClipboard
          text={resourceName}
          onCopy={() => {
            showSimpleInfo(SUCCESS_TEXT.copied);
          }}
        >
          <SVGIcon
            name="copy"
            size="sm"
            style={{
              cursor: "pointer",
              marginLeft: theme.spacing.spacing02,
            }}
          />
        </CopyToClipboard>
        <When condition={isNotEmpty(externalUrl)}>
          <ExternalLinkWithIndicator
            css={{ marginLeft: theme.spacing.spacing02 }}
            url={externalUrl}
            caption={caption}
          />
        </When>
      </FlexContainer>
      <FlexContainer>
        <ResourceDetails isVerticalBar bold value={category ?? ""} />
        <ResourceDetails isVerticalBar isEllipsis value={type ?? ""} />
        <ResourceDetails isEllipsis value={region ?? ""} />
      </FlexContainer>
    </>
  );
}
